interface Props {
	options: {
		contentAri: string;
	};
}

/**
 * TODO: EDITOR-6693
 * return type annotation is replicated for now since
 * there is a ratcheting rule on barrel exports so we can't add additional exports for now
 * in editor-plugin-ai-suggestions.
 */
export function aiSuggestionsOptions({ options }: Props): { contentAri: string } {
	return options;
}
